const getOrderResubmission = ({ orderInsuranceParam, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (orderInsuranceParam && insurance) {
    const activeOrderInsuranceParam = orderInsuranceParam.find(item => item['Insurance ID'] === insurance.ID);
    return activeOrderInsuranceParam ? activeOrderInsuranceParam.Resubmission : null;
  }
  return null;
};

export default getOrderResubmission;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderResubmission.js